import { rootApi } from "../../api/rootApi";

export const adminActivityApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenantLoginActivity: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/tenant-login-activity/${params.tenant_id}?limit=${params.limit || 100}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
      }),
    }),
  }),
});

export const { useGetTenantLoginActivityMutation } = adminActivityApi;
